export default __webpack_public_path__ + "1ec46683ce979075e70bf6cdd5f751d8.png";